require('/cloud/source_code/node_modules/_@alife_cn-sc-batch-input@0.1.11@@alife/cn-sc-batch-input/es/style.js');
import { componentName } from "./const";
import View from "./view";
import { withI18n } from '@alife/panda-i18n';
import locale from "./locale";
var Index = withI18n(View, {
  locale: locale
});
Index.displayName = componentName;
export default Index;